import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import MotionOpacity from '@components/motion/motion-opacity';
import Typography from '@components/basics/typography';
import BackIcon from '@components/basics/icons/back';
import { Translate } from 'react-localize-redux';
import { goBack } from 'connected-react-router';
import { UserCreatePasswordCtrl } from '@webapp/controllers/registration/user-create-password';

type CreatePasswordProps = {
  className?: string;
};
const CreatePasswordPage: React.FC<CreatePasswordProps> = ({
  className,
}): JSX.Element | null => {
  const dispatch = useDispatch();
  return (
    <MotionOpacity>
      <Wrapper className={className}>
        <BackIcon className="back-icon" onClick={() => dispatch(goBack())} />
        <Title type="subheader" customFont="semi-bold">
          <Translate id="USER.SETTINGS.SECURITY.PASSWORD.CREATE.NEW" />
        </Title>
        <UserCreatePasswordCtrl />
      </Wrapper>
    </MotionOpacity>
  );
};

export default CreatePasswordPage;

const Wrapper = styled.div`
  padding-top: 24px;
  .back-icon {
    margin-bottom: 20px;
    ${({ theme }) => `@media screen and ${theme.device.tablet}`} {
      position: absolute;
      top: 70px;
      left: 32px;
      margin: 0;
      width: 50px;
      height: 50px;
    }
  }
`;

const Title = styled(Typography)`
  margin-bottom: 30px;
`;
